import { useEffect, useRef } from "react";
import type { AppEvents } from "../../contexts/events";
import { useSdk } from "../../contexts/services/hooks/use-services-context";

/** Écoute `type` sur le bus de la session tant que le composant est monté. */
export function useSdkEvent<K extends keyof AppEvents>(
    type: K,
    handler: (event: AppEvents[K]) => void,
): void {
    const { sessionEventBus } = useSdk();
    const handlerRef = useRef(handler);

    useEffect(() => {
        handlerRef.current = handler;
    });

    useEffect(() => {
        const listener = (event: AppEvents[K]) => handlerRef.current(event);
        sessionEventBus.on(type, listener);

        return () => sessionEventBus.off(type, listener);
    }, [sessionEventBus, type]);
}
